export const TrackingNumberType = Object.freeze({
	None: 'none',
	Pic: 'pic',
	Planet: 'planet',
	Imb: 'imb',
});
